<script setup lang="ts">
import { ref } from 'vue'
import { PhCaretDown } from '@phosphor-icons/vue'
import { CollapsibleRoot, CollapsibleTrigger, CollapsibleContent } from 'reka-ui'

import AffiliateDisclaimerTrigger from './AffiliateDisclaimerTrigger.vue'
import AffiliateDisclaimerContent from './AffiliateDisclaimerContent.vue'

const open = ref(false)
</script>

<template>
  <CollapsibleRoot v-model:open="open"
                   class="w-full border border-separator rounded-affiliate-disclaimer p-3 overflow-hidden">
    <CollapsibleTrigger as-child>
      <AffiliateDisclaimerTrigger>
        <template #trigger-headline>
          <slot name="trigger" />
        </template>
        <i class="flex justify-center items-center w-action-sm h-action-sm rounded-action-secondary text-action-secondary-foreground bg-action-secondary-background border-2 border-action-secondary-stroke ml-auto">
          <PhCaretDown width="16"
                       height="16"
                       weight="bold"
                       :class="[open ? 'rotate-180' : '', 'transition duration-200']" />
        </i>
      </AffiliateDisclaimerTrigger>
    </CollapsibleTrigger>
    <CollapsibleContent class="overflow-hidden data-[state=open]:animate-slideDownCollapsible data-[state=closed]:animate-slideUpCollapsible">
      <AffiliateDisclaimerContent>
        <slot name="content" />
      </AffiliateDisclaimerContent>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>
